module.exports = {"220203001":"龙华街道","220203002":"湘潭街道","220203003":"铁东街道","220203004":"泡子沿街道","220203005":"龙潭街道","220203006":"新吉林街道","220203007":"山前街道","220203008":"新安街道","220203009":"遵义街道","220203010":"榆树街道","220203012":"东城街道","220203013":"承德街道","220203072":"靠山街道","220203100":"乌拉街镇","220203101":"缸窑镇","220203102":"江密峰镇","220203103":"大口钦镇","220203104":"金珠镇","220203200":"江北乡","220203400":"龙潭经济开发区","220203401":"金珠工业区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220203.json
// module id = 566
// module chunks = 0